import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { capitalize } from "@mui/material";
import { SendPostRequest } from "../../../http";
import Spinner from "../../Spinner";
import HeaderWrapper from "../../Header/HeaderWrapper";
import FooterWrapper from "../../Footer/FooterWrapper";
import TextMainBannerWrapper from "../../TextMainBanners/TextMainBannerWrapper";
import { limitParagraphByCharLimit } from "../../../Helper/Helper";

const animationList = ["fadeInLeft", "fadeInRight"];

function TimeLineServicesListing() {
  const sitedata = useSelector((store) => store.global.loginData);
  const timelineSectionRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isData, setIsdata] = useState(false);
  const [servicesData, setServicesData] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    getServicesData();
  }, []);

  const getServicesData = async () => {
    const response = await SendPostRequest("services/list");
    setIsLoading(false);
    if (!response?.data || response?.data?.length < 1) {
      setIsdata(true);
    } else {
      setServicesData(response.data);
    }
  };

  useEffect(() => {
    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const animatedItems = entry.target.querySelectorAll("li.animated");
          animatedItems.forEach((item, index) => {
            setTimeout(() => {
              const animationType = item.getAttribute("data-animation");
              if (!item.classList.contains("visible")) {
                item.classList.add(animationType, "visible");
              }
            }, index * 300);
          });
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      threshold: 0.1,
    });

    if (timelineSectionRef.current) {
      observer.observe(timelineSectionRef.current);
    }

    return () => {
      if (timelineSectionRef.current) {
        observer.unobserve(timelineSectionRef.current);
      }
    };
  }, [servicesData]);

  return (
    <div className="page-wrapper-inner">
      <HeaderWrapper />
      <TextMainBannerWrapper
        Heading={sitedata?.site_type === "hospitals" ? "Our Specialties" : "Services"}
        Image="theme-2-banner-speciality.webp"
      />


      <div className="container">
          {sitedata?.site_type === "hospitals" ? (
            <div className="row mt-5">
              <div className="offset-md-2 col-md-8">
                <div className="title-wrap text-center">
                  <div className="section-title margin-bottom-60">
                    <h2 className="section-title mb-0 text-uppercase">
                      Provides Our{" "}
                      <span className="theme-color">Best Specialties</span>
                    </h2>
                    <span className="section-border-bottom center"></span>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="mt-5"></div>
          )}

        {isLoading ? (
          <div className="text-center">
            <Spinner />
          </div>
        ) : isData ? (
          <div className="text-center mb-4">
            <h4>No Record Available</h4>
          </div>
        ) : (
          <section className="timeline-section pad-bottom-70" ref={timelineSectionRef}>
            <div className="timeline-wrapper">
              <ul className="timeline">
                {servicesData?.map((service, index) => (
                  <li
                    key={index}
                    className={`mb-5 animated ${index % 2 === 1 ? "timeline-inverted" : ""}`}
                    data-animation={animationList[index % 2]}
                    style={{ minHeight: "200px" }}
                  >
                    <div className="timeline-image">
                      <div
                        className="img-circle first-fservices-img-wrapper"
                        style={{
                          backgroundImage: `url(${service?.service_image_url})`,
                        }}
                      />
                    </div>
                    <div className="timeline-panel">
                      <Link
                        to={`/${sitedata?.site_type === "hospitals" ? "speciality" : "service"}/${service?.uid}/${service?.service_title
                          ?.replaceAll(" ", "-")
                          ?.replaceAll("/", "-")}`}
                      >
                        <div className="timeline-heading">
                          <h4 className="timeline-title text-uppercase first-fservices-title">
                            {service?.service_title}
                          </h4>
                        </div>
                        <div
                          className="timeline-body"
                          dangerouslySetInnerHTML={{
                            __html:
                              limitParagraphByCharLimit(service?.service_short_description, 190) +
                              (service?.service_short_description?.length > 190 ? "..." : ""),
                          }}
                        />
                      </Link>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </section>
        )}
      </div>
      <FooterWrapper />
    </div>
  );
}

export default TimeLineServicesListing;
